import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import './MenuPage.css';

class MenuForm extends Component {

  render() {
      // Every Link below also fires onNavigate (NavBar's toggle handler) on
      // click, in addition to its normal navigation. This is necessary
      // because React Router only remounts NavBar (which would otherwise
      // reset its own "menu open" state) when the route actually changes.
      // Clicking a menu item for the page the user is already on doesn't
      // change the route, so without this explicit call the menu stayed
      // open after clicking its own current page.
      const onNavigate = this.props.onNavigate;
      if (this.props.showLess) {
          return (
              <div className="menugroup">
                  <div className="menubtn menubtn-small-top">
                      <Link className="btna" to="/terms" onClick={onNavigate}>Terms & Conditions</Link>
                  </div>
                  <div className="menubtn menubtn-small">
                      <Link className="btna" to="/policy" onClick={onNavigate}>Privacy Policy</Link>
                  </div>
              </div>
          )
      } else {
          return (
              <div className="menugroup">
                  <div className="menubtn">
                      <Link className="btna" to="/yantra" onClick={onNavigate}>Reveal My Yantra</Link>
                  </div>
                  <div className="menubtn">
                      <Link className="btna" to="/save" onClick={onNavigate}>Saved Yantras</Link>
                  </div>
                  <div className="menubtn">
                      <Link className="btna" to="/about" onClick={onNavigate}>About Yantras</Link>
                  </div>
                  <div className="menubtn">
                      <Link className="btna" to="/delete" onClick={onNavigate}>Delete My Account</Link>
                  </div>
                  <div className="menubtn">
                      <button type="button" className="btna" onClick={this.props.onLogout}>Logout</button>
                  </div>
                  <div className="menubtn menubtn-small-top">
                      <Link className="btna" to="/terms" onClick={onNavigate}>Terms & Conditions</Link>
                  </div>
                  <div className="menubtn menubtn-small">
                      <Link className="btna" to="/policy" onClick={onNavigate}>Privacy Policy</Link>
                  </div>
              </div>
          )
      }
  }
}

class MenuPage extends Component {

  state = {
    redirect: false,
  }

  // Clears every bit of auth state this app stores (both social providers'
  // tokens plus the backend JWT and any leftover in-flight purchase tokens),
  // tells Google's SDK to stop auto-signing the user back in, then sends them
  // back to the login page.
  handleLogout = () => {
      localStorage.removeItem('fb_access_token');
      localStorage.removeItem('google_access_token');
      localStorage.removeItem('y_jwt_token');
      localStorage.removeItem('fb_purchase_token');
      localStorage.removeItem('bt_nonce');

      if (window.google && window.google.accounts && window.google.accounts.id) {
          window.google.accounts.id.disableAutoSelect();
      }
      if (window.FB && typeof window.FB.logout === 'function') {
          window.FB.logout();
      }

      this.setState({redirect: true});
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <div className="MenuPage">
          <MenuForm showLess={this.props.showLess} onLogout={this.handleLogout} onNavigate={this.props.onNavigate} />
          <Link to="/" onClick={this.props.onNavigate}>
            <div className="menu-logo"></div>
          </Link>
      </div>
    )
  }
}

export default MenuPage;



// WEBPACK FOOTER //
// ./src/components/MenuPage/MenuPage.js